import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { SecurityManagerService } from '@iupics-manager/managers/security-manager/security-manager.service';
import { UserAccount } from '@iupics-manager/models/user-account';
import { DocIconPipe } from '@iupics-util/pipes/doc-icon/doc-icon.pipe';
import { TranslateModule } from '@ngx-translate/core';
import AvatarUiComponent from '../../user/avatar-ui/avatar-ui.component';
import NotesPanelUiComponent from '../notes-panel-ui/notes-panel-ui.component';
import { NoteAttachment, NoteEntry, NoteType } from '../notes.interface';
import { renderNoteContent } from './note-content.util';

@Component({
  selector: 'iu-note-ui',
  templateUrl: './note-ui.component.html',
  styleUrls: ['./note-ui.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarUiComponent, TranslateModule, DocIconPipe],
})
export default class NoteUiComponent implements OnChanges {
  readonly #connectorService = inject(SecurityManagerService);

  @Input() note: NoteEntry;
  @Input() type: NoteType = 'TEXT';
  @Input() parent: NotesPanelUiComponent;

  /* Users infos */
  me: UserAccount = this.#connectorService.getIupicsUserAccount();

  isMine = false;
  /** content as HTML (text escaped, mentions as chips) */
  html = '';

  ngOnChanges(): void {
    this.isMine = this.note?.author?.id === this.me?.id;
    this.html = renderNoteContent(this.note?.content, this.me?.id);
  }

  download(attachment: NoteAttachment): void {
    this.parent?.downloadEntryAttachment(attachment);
  }
}
